import React from 'react'
import { Control, FieldErrors, FieldValues, UseFormHandleSubmit } from 'react-hook-form/dist/types'

import { InputTypes, NumberXYValues } from 'Shared/molecules/Form/types'

export declare namespace Form {
	interface Props<T extends FieldValues> extends SectionProps<T> {
		handleSubmit: UseFormHandleSubmit<T>
		onSave: (data: T) => void
		onSaveEdit?: (data: T) => void
		isDirty: boolean
		errors: FieldErrors
	}

	interface SectionProps<T extends FieldValues> {
		control: Control<T>
	}
}

export interface EditTableConfig<
	SelectFieldNames extends string,
	InputFieldNames extends string,
	DatePickerFieldNames extends string,
	SwitchFieldNames extends string | never = never
> {
	selects: Record<
		SelectFieldNames,
		{
			getOptions?: (params: Record<string, number | string | null>) => Promise<LabelValue[]>
			params?: Record<string, number | string | null>
			props: {
				placeholder: string
				fieldName: SelectFieldNames
				options?: LabelValue<number>[]
				allowClear?: boolean
			}
		}
	>
	inputs: Record<
		InputFieldNames,
		{
			props: {
				placeholder: string
				fieldName: InputFieldNames
				numberXYValues?: NumberXYValues
				type?: InputTypes
				maxLength?: number
				suffix?: string | React.ReactNode
			}
		}
	>
	datePickers: Record<
		DatePickerFieldNames,
		{
			props: {
				fieldName: DatePickerFieldNames
				format?: string
			}
		}
	>

	switches: Record<
		SwitchFieldNames,
		{
			props: {
				fieldName: SwitchFieldNames
				value: true
			}
		}
	>
}

export enum CellEditType {
	select = 'select',
	input = 'input',
	date = 'date',
	switch = 'switch'
}
